import React, { useContext, useMemo, useState } from "react";
import { useTextDomainContext, useUser } from "@/app/providers";
import { ActionMenu, ConfirmNotification, TableView1 } from "@/components";
import {
  useDeleteAllNotifications,
  useDeleteNotification,
  useGetAllNotifications,
  usePageTitle,
  useReadAllNotifications,
  useReadNotification,
  useUnreadNotification,
  useUserProfile,
} from "@/hooks";
import { formatTimeAgo } from "@/utils";
import moment from "moment";
import {
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MailIcon from "@mui/icons-material/Mail";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import { useNavigate, useParams } from "react-router";

// import { Button, Modal, Spinner } from "react-bootstrap";

interface NotificationProps {
  userId?: string;
}

export const Notification: React.FC<NotificationProps> = ({
  userId: propUserId,
}) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { user } = useUser();
  const navigate = useNavigate();
  const params = useParams<{ userId?: string }>();
  const userId = propUserId || params.userId;

  const { userProfile } = useUserProfile({
    userId: userId || undefined,
  });

  usePageTitle(
    userProfile?.name
      ? `${userProfile.name} - ${gettext("Notifications")}`
      : gettext("Notifications"),
  );

  const notificationVariables = useMemo(() => {
    if (userId) {
      return { userId, email: userProfile?.email };
    }
    return { email: user?.email };
  }, [userId, userProfile?.email, user?.email]);

  const { notificationList, loading } = useGetAllNotifications(
    notificationVariables,
  );
  const { deleteNotification, deleting } = useDeleteNotification();
  const { deleteAllNotifications, deletingAll } = useDeleteAllNotifications(
    undefined,
    undefined,
    notificationVariables,
  );
  const { readNotification, reading } = useReadNotification();
  const { unreadNotification } = useUnreadNotification();
  const { readAllNotifications, readingAll } = useReadAllNotifications(
    undefined,
    undefined,
    notificationVariables,
  );

  // const [filteredList, setFilteredList] = useState([]);
  // const [deleteLoading, setDeleteLoading] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [dialogParameters, setDialogParameters] = useState({});

  // const [notificationDelete] = useMutation<any>(DELETE_NOTIFICATION, {
  //   onCompleted() {
  //     // setDeleteLoading(false);
  //     // setdelete(false);
  //   },
  //   onError() {
  //     // setDeleteLoading(false);
  //   },
  //   refetchQueries: ["comGetAllNotifications"],
  // });

  // const [readNotification] = useMutation<any>(READ_NOTIFICATION, {
  //   onCompleted() {},
  //   onError() {},
  //   refetchQueries: ["comGetAllNotifications"],
  // });

  // const onDeleteNotification = () => {
  //   setDeleteLoading(true);
  //   notificationDelete({
  //     variables: {
  //       notificationId: notificationID
  //     }
  //   });
  // };
  // const handleDeleteNotification = () => {
  //   // notification
  //   // setNotificationID(notification);
  //   // showDeleteModal();
  // };

  // const handleShowNotificationModal = (notification) => {
  //   !notification?.row?.Read &&
  //     readNotification({
  //       variables: {
  //         notificationId: notification?.id,
  //       },
  //     });
  //
  //   // setNotificationMessage(notification?.row?.Message);
  //   // setShowNotification(true);
  // };

  // useEffect(() => {
  //   if (!loading) {
  //     setFilteredList(notificationData);
  //     setNotificationData(data ? data?.comGetAllNotifications : []);
  //   } else {
  //     setFilteredList("");
  //   }
  // }, [data, notificationDelete, notificationData, loading]);

  // const filterBySearch = (event) => {
  //   // Access input value
  //   const query = event.target.value;
  //   // Create copy of item list
  //   const updatedList = [...notificationData];
  //   // Include all elements which includes the search query
  //   const NewUpdatedList = updatedList.filter((item) => {
  //     return item?.Message.toLowerCase().indexOf(query.toLowerCase()) !== -1;
  //   });
  //   // Trigger render with updated values
  //   setFilteredList(NewUpdatedList);
  // };

  /**
   *
   * @param params
   */
  // function columnFormater(params) {
  //   return (
  //     <div className="w-100 d-flex justify-content-center">
  //       <Tooltip title={gettext("Read Notification")} arrow>
  //         <IconButton onClick={() => handleShowNotificationModal(params)}>
  //           <VisibilityIcon size={16} />
  //         </IconButton>
  //       </Tooltip>
  //       <Tooltip title={gettext("Delete")} arrow>
  //         <IconButton onClick={() => handleDeleteNotification(params?.id)}>
  //           <MdDelete size={16} />
  //         </IconButton>
  //       </Tooltip>
  //     </div>
  //   );
  // }

  /**
   *
   * @param params
   */
  // function showMessage(params) {
  //   return (
  //     <div>
  //       {params?.row?.Read ? (
  //         <Typography fontSize="0.875rem" fontWeight={400}>
  //           {gettext(params?.row?.Message)}
  //         </Typography>
  //       ) : (
  //         <Typography fontSize="0.875rem" fontWeight={700}>
  //           {gettext(params?.row?.Message)}
  //         </Typography>
  //       )}
  //     </div>
  //   );
  // }

  /**
   *
   * @param params
   */
  // function showEmail(params) {
  //   return (
  //     <div>
  //       {params?.row?.Read ? (
  //         <Typography fontSize="0.875rem" fontWeight={400}>
  //           {gettext(params?.row?.email)}
  //         </Typography>
  //       ) : (
  //         <Typography fontSize="0.875rem" fontWeight={700}>
  //           {gettext(params?.row?.email)}
  //         </Typography>
  //       )}
  //     </div>
  //   );
  // }

  /**
   *
   * @param action
   * @param id
   */
  // function showDate(params) {
  //   return (
  //     <div>
  //       {params?.row?.Read ? (
  //         <Typography fontSize="0.875rem" fontWeight={400}>
  //           {moment(params?.row?.date).format("DD/MM/YYYY hh:mm A")}
  //         </Typography>
  //       ) : (
  //         <Typography fontSize="0.875rem" fontWeight={700}>
  //           {moment(params?.row?.date).format("DD/MM/YYYY hh:mm A")}
  //         </Typography>
  //       )}
  //     </div>
  //   );
  // }

  const handleOnClickDelete = (
    action: string,
    id: string | number | undefined,
  ) => {
    setDialogParameters({
      action,
      id,
    });
    setShowConfirm(true);
  };

  const handleGetResult = (obj: any) => {
    if (obj.result === "yes") {
      switch (obj?.parameters?.action) {
        case "notification-delete":
          deleteNotification({
            notificationId: obj?.parameters?.id,
          });
          break;
        default:
          break;
      }
    }
    setShowConfirm(false);
  };

  const initialState = {
    pagination: {
      paginationModel: {
        page: 0,
        pageSize: 100,
      },
    },
    columns: {
      columnVisibilityModel: {
        // id: false,
        // name: true,
        email: false,
        // role: false,
        // country: false,
        // timezone: false,
        // status: true,
        // partnerName: false,
      },
    },
  };

  const handleOpenNotification = (row: any) => {
    if (!row?.id) return;
    const basePath = location.pathname.replace(/\/+$/, "");
    navigate(`${basePath}/${row.id}`, {
      state: {
        notification: row,
      },
    });
  };

  const menuClick = (action: string, row: any) => {
    switch (action) {
      case "notification-view":
      case "notification-open":
        handleOpenNotification(row);
        break;
      case "notification-read":
        readNotification({
          notificationId: row?.id,
        });
        break;
      case "notification-unread":
        unreadNotification({
          notificationId: row?.id,
        });
        break;
      case "notification-delete":
        setConfirmMessage(gettext("Do you want to delete the notification?"));
        handleOnClickDelete(action, row?.id);
        break;
      default:
        break;
    }
    // console.log(action, row);
  };

  const columns = [
    {
      field: "Read",
      headerName: gettext("Status"),
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => {
        const isRead = Boolean(params.row?.Read);
        if (isRead) {
          return (
            <Tooltip title={gettext("Read")} arrow>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                }}
              >
                <DraftsOutlinedIcon
                  fontSize="small"
                  sx={{ color: "text.secondary" }}
                />
              </Box>
            </Tooltip>
          );
        }

        return (
          <Tooltip title={gettext("Unread - Click to mark as read")} arrow>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  readNotification({
                    notificationId: params.row?.id,
                  });
                }}
              >
                <MailIcon color="primary" fontSize="small" />
              </IconButton>
            </Box>
          </Tooltip>
        );
      },
    },
    {
      field: "Subject",
      headerName: gettext("Subject"),
      flex: 3,
      headerAlign: "left",
      renderCell: (params: any) => {
        const isRead = Boolean(params.row?.Read);
        const subjectText =
          params.row?.Subject || params.row?.Message || gettext("No Subject");
        const preview = params.row?.Message
          ? ` - ${params.row.Message.replace(/\s+/g, " ").trim()}`
          : "";

        return (
          <Box
            onClick={() => handleOpenNotification(params.row)}
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
              cursor: "pointer",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              "&:hover .subject-text": {
                textDecoration: "underline",
                color: "primary.main",
              },
            }}
          >
            <Typography
              component="span"
              className="subject-text"
              sx={{
                fontWeight: isRead ? 400 : 700,
                color: "text.primary",
                fontSize: "0.875rem",
                mr: 1,
                flexShrink: 0,
              }}
            >
              {subjectText}
            </Typography>
            {params.row?.Subject && params.row?.Message && (
              <Typography
                component="span"
                sx={{
                  color: "text.secondary",
                  fontSize: "0.875rem",
                  fontWeight: 400,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  opacity: 0.8,
                }}
              >
                {preview}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "email",
      headerName: gettext("Email"),
      flex: 1,
      headerAlign: "left",
      // renderCell: (params) => showEmail(params),
    },
    {
      field: "date",
      headerName: gettext("Date"),
      headerAlign: "left",
      width: 175,
      type: "date",
      valueGetter: (value: unknown) => {
        if (!value) return null;
        const m = moment.utc(value as string | number | Date);
        return m.isValid() ? m.toDate() : null;
      },
      valueFormatter: (value: unknown) =>
        value ? formatTimeAgo(value as string | number | Date) : "",
    },
    {
      field: "actions",
      type: "actions",
      headerName: gettext("Actions"),
      hideable: false,
      maxWidth: 100,
      align: "right",
      headerAlign: "right",
      // renderCell: (params) => columnFormater(params),
      renderCell: (params: any) => (
        <ActionMenu
          menuFor="notification"
          row={params.row}
          menuClick={menuClick}
        />
      ),
    },
  ];
  // return (<>
  //   <TableView1>
  //     title={gettext("Notifications")}
  //     rows={notificationList}
  //     columns={columns}
  //   </TableView1>
  // </>);
  return (
    <>
      <TableView1
        title={
          userProfile?.name
            ? `${gettext("Notifications")} - ${userProfile.name}`
            : gettext("Notifications")
        }
        rows={notificationList}
        // rows={[]}
        columns={columns}
        loading={loading || deleting || deletingAll || reading || readingAll}
        initialState={initialState}
        showGridToolbar
        showGridToolbarQuickFilter
        onRowClick={(params: any) => handleOpenNotification(params.row)}
        sx={{
          "& .MuiDataGrid-row": {
            cursor: "pointer",
          },
        }}
        getRowClassName={(params: any) => {
          let returnValue = "";

          if (!params?.row?.Read) {
            returnValue = "unread-row";
          }
          return returnValue;
        }}
        postToolbar={
          <Stack
            direction="row"
            spacing={1}
            sx={{ pl: 1, alignItems: "center" }}
          >
            {userId && (
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(-1)}
                sx={{
                  textTransform: "none",
                }}
              >
                {gettext("Back")}
              </Button>
            )}
            <Button
              variant="contained"
              onClick={() => readAllNotifications()}
              disabled={loading || readingAll || deletingAll}
              sx={{
                textTransform: "none",
                color: "primary",
              }}
            >
              {gettext("Read All Notifications")}
            </Button>
            <Button
              variant="contained"
              onClick={() => deleteAllNotifications()}
              disabled={loading || deletingAll || readingAll}
              sx={{
                textTransform: "none",
                color: "error",
              }}
            >
              {gettext("Delete All Notifications")}
            </Button>
          </Stack>
        }
      />

      <ConfirmNotification
        isOpen={showConfirm}
        parameters={dialogParameters}
        getResult={handleGetResult}
        message={confirmMessage}
      />

      {/*<Grid container spacing={4}>*/}
      {/*  <Grid size={{xs: 12}}>*/}
      {/*    <Grid container>*/}
      {/*      <Grid size={{xs: 6}}>*/}
      {/*        <Typography fontSize={22} fontWeight={700}>*/}
      {/*          {gettext("Notifications")}*/}
      {/*        </Typography>*/}
      {/*      </Grid>*/}

      {/*      <Grid size={{xs: 6}}>*/}
      {/*        <Box*/}
      {/*          sx={{*/}
      {/*            display: "flex",*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          <Box*/}
      {/*            sx={{*/}
      {/*              flex: 1,*/}
      {/*            }}*/}
      {/*          />*/}

      {/*          <Stack direction={"row"} spacing={2}>*/}
      {/*            <OutlinedInput*/}
      {/*              type={"text"}*/}
      {/*              size="small"*/}
      {/*              placeholder="Search"*/}
      {/*              onChange={filterBySearch}*/}
      {/*              endAdornment={*/}
      {/*                <InputAdornment position="end">*/}
      {/*                  <IconButton edge="end">*/}
      {/*                    <SearchIcon />*/}
      {/*                  </IconButton>*/}
      {/*                </InputAdornment>*/}
      {/*              }*/}
      {/*            />*/}
      {/*          </Stack>*/}
      {/*        </Box>*/}
      {/*      </Grid>*/}
      {/*    </Grid>*/}
      {/*  </Grid>*/}

      {/*  <Grid size={{xs: 12}}>*/}
      {/*    <DataGridComponent*/}
      {/*      rows={filteredList}*/}
      {/*      columns={columns}*/}
      {/*      loading={loading}*/}
      {/*      disableSelectionOnClick={true}*/}
      {/*      autoHeight*/}
      {/*    />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}

      {/*<Modal*/}
      {/*  show={delete_show}*/}
      {/*  onHide={closeDeleteModal}*/}
      {/*  animation*/}
      {/*  size="lg"*/}
      {/*  aria-labelledby=""*/}
      {/*  centered*/}
      {/*  style={{*/}
      {/*    backgroundColor: "transparent"*/}
      {/*  }}*/}
      {/*>*/}
      {/*  /!*<Modal.Header closeButton>*!/*/}
      {/*  /!*  <Modal.Title>Delete Notification</Modal.Title>*!/*/}
      {/*  /!*</Modal.Header>*!/*/}
      {/*  /!*<Modal.Body>*!/*/}
      {/*  /!*  {gettext("Are you sure you want to delete this notification ? ")}*!/*/}
      {/*  /!*</Modal.Body>*!/*/}
      {/*  /!*<Modal.Footer>*!/*/}
      {/*  /!*  <Button variant="secondary" onClick={closeDeleteModal}>*!/*/}
      {/*  /!*    {gettext("Close")}*!/*/}
      {/*  /!*  </Button>*!/*/}
      {/*  /!*  {loading ? (*!/*/}
      {/*  /!*    <Spinner animation="border" variant="dark" />*!/*/}
      {/*  /!*  ) : (*!/*/}
      {/*  /!*    <Button variant="primary" onClick={onDeleteNotification}>*!/*/}
      {/*  /!*      {gettext("Delete")}*!/*/}
      {/*  /!*    </Button>*!/*/}
      {/*  /!*  )}*!/*/}
      {/*  /!*</Modal.Footer>*!/*/}
      {/*  {deleteLoading ? (*/}
      {/*    <div*/}
      {/*      className="position-absolute bg-dark opacity-50 w-100 h-100 d-flex justify-content-center align-items-center">*/}
      {/*      /!*<Spinner animation="border" variant="light" />*!/*/}
      {/*    </div>*/}
      {/*  ) : null}*/}
      {/*</Modal>*/}
      {/*<Modal*/}
      {/*  show={showNotification}*/}
      {/*  onHide={closeNotificationModal}*/}
      {/*  animation*/}
      {/*  size="lg"*/}
      {/*  aria-labelledby=""*/}
      {/*  centered*/}
      {/*  style={{*/}
      {/*    backgroundColor: "transparent"*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <Modal.Header closeButton>*/}
      {/*    <Modal.Title>Notification</Modal.Title>*/}
      {/*  </Modal.Header>*/}
      {/*  <Modal.Body>{gettext(notificationMessage)}</Modal.Body>*/}
      {/*  <Modal.Footer>*/}
      {/*    <Button variant="secondary" onClick={closeNotificationModal}>*/}
      {/*      {gettext("Close")}*/}
      {/*    </Button>*/}
      {/*  </Modal.Footer>*/}
      {/*</Modal>*/}
    </>
  );
};
// export default Notification;
